/**
 * Insurance Summaries Page
 * Secret route for generating insurance medical record summaries
 */

import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import NavigationBar from '../components/NavigationBar';
import InsuranceSummaryWizard from '../components/insurance/InsuranceSummaryWizard';

interface InsuranceSummariesPageProps {
  signOut: () => void;
}

const InsuranceSummariesPage: React.FC<InsuranceSummariesPageProps> = ({ signOut }) => {
  const { reportId } = useParams<{ reportId?: string }>();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <NavigationBar onSignOut={signOut} />
      <Box sx={{ flexGrow: 1, pt: '64px', overflow: 'auto' }}>
        <Container maxWidth="lg" sx={{ py: 4 }}>
          <InsuranceSummaryWizard key={reportId || 'new'} initialReportId={reportId} />
        </Container>
      </Box>
    </Box>
  );
};

export default InsuranceSummariesPage;
